const TipoDocumento =[
    {id:"1",nombre:"application/pdf"}, 
    {id:"2",nombre:"application/jpeg"},
    {id:"3",nombre:"application/jpg"},
    {id:"4",nombre:"application/png"}, 
    {id:"5",nombre:"application/gif"},
    {id:"6",nombre:"application/tiff"},
    {id:"7",nombre:"image/png"},
    {id:"8",nombre:"image/gif"}, 
    {id:"9",nombre:"image/jpeg"},
    {id:"10",nombre:"image/tiff"}, 
    {id:"11",nombre:"image/jpg"}
    ]


export default TipoDocumento;